export default __webpack_public_path__ + "static/media/trackButton.fe0906d5.svg";